module.exports = __webpack_public_path__ + "media/xs-super-intro.69f60097.mp4";